import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class RewardsModel extends ThemeComponent {
    @Ref modalTrigger!: HTMLElement;
    @Ref modalClose!: HTMLElement;
    @Ref modalContent!: HTMLElement;
    private siteFooter: HTMLElement|null = document.querySelector('.site-footer');

    init() {
        this.$listen(this.modalTrigger, 'click', this.handleModalTrigger.bind(this));
        this.$listen(this.modalClose, 'click', this.handleModalClose.bind(this));
        this.observeFooter();
    }

    handleModalTrigger() {
        this.classList.toggle('is-visible');
        if (window.innerWidth < 768) {
            document.body.classList.toggle('drawer-open');
        }
    }

    handleModalClose() {
        this.classList.remove('is-visible');
        if (window.innerWidth < 768) {
            document.body.classList.toggle('drawer-open');
        }
    }

    private observeFooter() {
        if (!this.siteFooter) {return;}

        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    document.body.classList.add('hide-rewards');
                } else {
                    document.body.classList.remove('hide-rewards');
                }
            }
        }, {
            threshold: 0.1
        });

        observer.observe(this.siteFooter);
    }


}
